var map = {
	"./arabica0/berry.png": "e113",
	"./arabica0/chocolate.png": "10a9",
	"./arabica0/image.png": "5d3a",
	"./brazilian0/chocolate.png": "4411",
	"./brazilian0/hazelnut.png": "496c",
	"./brazilian0/image.png": "67f6",
	"./colombian0/caramel.png": "1b99",
	"./colombian0/image.png": "a861",
	"./colombian0/peanut.png": "0701",
	"./columbian0/caramel.png": "17b6",
	"./columbian0/chocolate.png": "d0e9",
	"./columbian0/image.png": "6aac",
	"./costarika0/cardamom.png": "7437",
	"./costarika0/image.png": "65a0",
	"./costarika0/orange.png": "d901",
	"./guatemala0/cardamom.png": "12d5",
	"./guatemala0/cinnamon.png": "bd4a",
	"./guatemala0/image.png": "2a47",
	"./indonesian0/cinnamon.png": "fb4a",
	"./indonesian0/image.png": "d477",
	"./indonesian0/vanilla.png": "a995"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b5eb";